import { mapUrlToPageLogProps, Page } from 'components/Logs'
import Main from './UsersMain'
import New from './UsersNew'
import Edit from './UsersEdit'

export default {
  Main,
  New,
  Edit,
  Logs: mapUrlToPageLogProps(({ params }) => ({
    title: 'Usuário',
    entity: 'user',
    entityId: params.userId,
  }))(Page),
}
